import { PremiumFunctionType, usePremiumValidator } from "@/services/PremiumValidator";
import { Checkbox, Popover, Tooltip } from "antd";
import React from "react";
import { FlexibleSelectFooterProps, SelectType } from "./type";
import { QuestionCircleFilled } from "@ant-design/icons";

const FlexibleSelectFooter: React.FC<FlexibleSelectFooterProps> = function (props) {
    const {
        type,
        multiple,
        onMultipleChange,
        shopId,
        onSimpleTitleChange,
        needSimpleTitle,
        enabledTopSellingProductPrinting,
        onEnabledTopSellingProductPrintingChange,
        needSkuSimpleTitle,
        onSkuSimpleTitleChange,
        showTitlePic,
        onShowTitlePicChange,
    } = props;
    const { validate: premiumValidate } = usePremiumValidator();

    async function handleMultipleCheckboxChange(e) {
        const checked = e.target.checked;

        onMultipleChange(checked);
    }

    async function handleSwitchTopSellingProductPrinting(checked) {
        if (checked && shopId) {
            const flag = await premiumValidate({
                shopId,
                type: PremiumFunctionType.TOP_SELLING_PRODUCT_PRINTING,
            });

            if (!flag) {
                return;
            }
        }

        onEnabledTopSellingProductPrintingChange(checked);
    }

    return (
        <div className="footer p5">
            <span className="ml5 text-small text-gray">信息展示设置:</span>
            <Tooltip title="勾选后可以选中多个商品" placement="bottom">
                <Checkbox className="ml10 small" checked={multiple} onChange={handleMultipleCheckboxChange}>
                    多选商品
                </Checkbox>
            </Tooltip>

            {[SelectType.SKU_PROPERTIES].includes(type) ? (
                <Tooltip title="勾选后下拉列表优先属性级别的简称" placement="bottom">
                    <Checkbox
                        className="small"
                        style={{ marginLeft: "2px" }}
                        checked={needSkuSimpleTitle}
                        onChange={(e) => {
                            onSkuSimpleTitleChange?.(e.target.checked);
                        }}
                    >
                        优先简称
                    </Checkbox>
                </Tooltip>
            ) : null}

            {[SelectType.ORDER_ITEM_TITLE].includes(type) ? (
                <Tooltip title="勾选后下拉列表优先显示简称" placement="bottom">
                    <Checkbox
                        className="small"
                        style={{ marginLeft: "2px" }}
                        checked={needSimpleTitle}
                        onChange={(e) => {
                            onSimpleTitleChange?.(e.target.checked);
                        }}
                    >
                        优先简称
                    </Checkbox>
                </Tooltip>
            ) : null}

            {[SelectType.ORDER_ITEM_TITLE].includes(type) ? (
                <Checkbox
                    className="small"
                    style={{ marginLeft: "2px" }}
                    checked={showTitlePic}
                    onChange={(e) => {
                        onShowTitlePicChange?.(e.target.checked);
                    }}
                >
                    展示图片
                    <Popover content="开启后如果未能正常显示图片请到“设置”—“商品设置”下先同步商品信息" zIndex={9999}>
                        <QuestionCircleFilled />
                    </Popover>
                </Checkbox>
            ) : null}

            {[SelectType.ORDER_ITEM_TITLE, SelectType.SKU_PROPERTIES].includes(type) ? (
                <Tooltip
                    placement="bottom"
                    title={
                        <span>
                            统计待发货当前页面商品数量，会根据同步的订单实时统计。可在商品名称和属性下拉查看，开启爆款后相同商品属性名称或者商品编码名称在下拉中不会合并展示和统计
                            <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnhXwRiWgtCkUUmYLntgMYee" target="_blank">
                                爆款模式如何打单?
                            </a>
                        </span>
                    }
                >
                    <Checkbox
                        className="small"
                        style={{ marginLeft: "2px" }}
                        checked={enabledTopSellingProductPrinting}
                        onChange={(e) => {
                            handleSwitchTopSellingProductPrinting?.(e.target.checked);
                        }}
                    >
                        爆款模式
                        <span className="text-gray" style={{ fontSize: "9px" }}>
                            (仅统计当前页商品数量)
                        </span>
                    </Checkbox>
                </Tooltip>
            ) : null}
        </div>
    );
};

export default React.memo(FlexibleSelectFooter);
